import { images } from '../../constants';

const skills = [
  {
    id: 1,
    name: 'React',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.react,
  },
  {
    id: 2,
    name: 'Redux',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.redux,
  },
  {
    id: 3,
    name: 'Ruby on Rails',
    title: 'JavaScript',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.rails,
  },
  {
    id: 4,
    name: 'Python',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.python,
  },
  {
    id: 5,
    name: 'Postgresql',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.sql,
  },
  {
    id: 6,
    name: 'Git',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.git,
  },
  {
    id: 7,
    name: 'Sass',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.sass,
  },
  {
    id: 8,
    name: 'Figma',
    bgColor: 'rgba(255, 255, 255, 0.585)',
    icon: images.figma,
  },
];

export const experiences = [
  {
    id: 1,
    year: '2019 - Present',
    works: [
      {
        id: 1,
        name: 'Founder & CEO',
        company: 'NEUTRAL',
        desc: 'As a Chief executive officer, am responsible for implementing existing plans and policies, improving the my company\'s financial strength, supporting ongoing digital business transformation and setting future strategy',
      },
    ],
  },
  {
    id: 2,
    year: '2021 - 2022',
    works: [
      {
        id: 1,
        name: 'Full Stack Developer',
        company: 'MICROVERSE',
        desc: '• Spending 1300+ hours mastering algorithms, data structures, and technologies in web development while simultaneously developing projects with JavaScript, React, and Redux. • Gaining professional experience with industry best practices (Git Flow, Linter, pair programming, OOP, SOLID, MVC, TDD). • Developing skills in remote pair-programming using Git, GitHub, and daily standup\'s to communicate and collaborate with international remote developers through zoom call',
      },
    ],
  },
  {
    id: 3,
    year: '2021 - present',
    works: [
      {
        id: 1,
        name: 'Technical support engineer(TSE)',
        company: 'MICROVERSE',
        desc: 'Reviewing junior developers code in Html, JavaScript, ReactJS Ruby and Rails. providing feedback to help them improve their skills and become better developers',

      },
    ],
  },
];
export default skills;
